import React, { useContext } from 'react';
import { AuthContext } from '../App';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const TermsOfService = () => {
  const { nightMode } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <div className={`min-h-screen ${nightMode ? 'night-gradient text-white' : 'playful-gradient text-gray-900'} page-enter`}>
      <div className="container mx-auto px-6 py-8 max-w-4xl">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-6"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back
        </Button>

        <div className={`p-8 rounded-2xl shadow-xl ${nightMode ? 'bg-gray-800/90' : 'bg-white/90 backdrop-blur-sm'}`}>
          <h1 className="text-3xl font-bold mb-6" style={{ fontFamily: 'Fredoka, sans-serif' }}>Terms and Conditions</h1>
          
          <div className="prose max-w-none space-y-6">
            <p><strong>Effective Date:</strong> January 1, 2026</p>

            <section>
              <h2 className="text-xl font-bold mb-3">1. Acceptance of Terms</h2>
              <p>
                By accessing, downloading or using Dream Canvas Maker or StoryTime Studio (collectively referred to as “the App”), you agree to these Terms and Conditions. If you do not agree, please discontinue use immediately.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">2. Eligibility</h2>
              <p>
                You must be legally capable of entering into agreements under applicable laws to use the App. If you are using the App on behalf of a minor, you confirm that you have the authority to do so.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">3. Permitted Use</h2>
              <p>You agree to use the App only for lawful purposes and in accordance with these Terms. You must not:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Violate any applicable local, national, or international laws or regulations.</li>
                <li>Use the App in any way that may cause harm, harassment, or inconvenience to others.</li>
                <li>Attempt to gain unauthorized access to any part of the App or its systems.</li>
                <li>Upload or transmit harmful content, including viruses or malicious code.</li>
                <li>Flood, abuse, overload, or disrupt the App’s services or infrastructure.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">4. Account Responsibilities</h2>
              <p>If you create an account, you are responsible for:</p>
              <ul className="list-disc pl-6 mt-2 space-y-1">
                <li>Maintaining the confidentiality of your login credentials.</li>
                <li>Ensuring all information provided is accurate and up to date.</li>
                <li>Not sharing your account with unauthorized users.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">5. Intellectual Property</h2>
              <p>
                All content, features, and functionality of the App are owned by Dream Canvas Maker and protected by intellectual property laws. You may not copy, modify, distribute, or reverse-engineer any part of the App.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">6. Payments</h2>
              <p>
                If the App offers paid features, you agree to provide accurate payment information and authorize us to process payments through our secure payment provider.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">7. Limitation of Liability</h2>
              <p>
                We are not liable for any indirect, incidental, or consequential damages arising from your use of the App. The App is provided “as is” without warranties of any kind.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">8. Termination</h2>
              <p>
                We reserve the right to suspend or terminate your access to the App if you violate these Terms or engage in prohibited activities.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">9. Changes to Terms</h2>
              <p>
                We may update these Terms from time to time. Continued use of the App after changes indicates your acceptance of the updated Terms.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">10. Governing Law</h2>
              <p>
                These Terms are governed by the laws of Queensland, Australia. Any disputes will be resolved in the courts of Queensland, Australia.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold mb-3">11. Contact Us</h2>
              <p>For questions about these Terms, contact us at:</p>
              <p className="mt-2">
                <strong>Email:</strong> support@dreamcanvasmaker.com
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;